import {	BrowserRouter,
	Routes,
	Route,
	Navigate,
	useNavigate,
} from "react-router-dom";
import Checkout from "./Componants/checkout/Checkout";
import Productdetails from "./Componants/productdetails/Productdetails";
import Profile from "./Componants/profile/Profile";
import Cart from "./Componants/cart/Cart";
import Wishlist from "./Componants/wishlist/WishlistPage";
import Home from "./Componants/home/Home";
import Layout from "./Componants/Layout";
import {update} from "./network/api/personal_cookies";
import RouteRedirect from "./Componants/RouteRedirect";
import ForgitPassPop, {ConfirmemailPop} from "./Componants/Login/ForgitPassPop";
import Confirmpayment from "./Componants/Payment_PopUs/Confirmpayment";
import Confirmpayment2 from "./Componants/Payment_PopUs/Confirmpayment2";
import SubcatigoryPage from "./Componants/subcatigory/SubcatigoryPage";
import React, {useState, useEffect} from "react";
import {useTranslation} from "react-i18next";
import i18next from "i18next";
import cookies from "js-cookie";
import {ShoppinghcartProvider} from "./Componants/wishlist/Wishlistcontext";
import SearchPage from "./Componants/search/SearchPage";
import Fotter from "./Componants/Footer/Fotter";
import NotFoundPage from "./Componants/NotFoundPage";
import Sections from "./Componants/sections/Sections";
import SearchProduct from "./Componants/searchComponent/SearchProduct.js";
import Recovery from "./Componants/profile/Recovery.js";
import Orders from "./Componants/profile/Orders.js";
import Location from "./Componants/profile/Location.js";
import Wallet from "./Componants/profile/Wallet.js";
import ChangePassword from "./Componants/profile/ChangePassword.js";
import Modall from "./UI/Modal.js";
import WalletPopup from "./Componants/profile/WalletPopup.js";
import CustomResponse from "./Componants/CustomResponse.js";
import SearchResult from "./Componants/searchwithimage/SearchResult.jsx";
import WeAre from "./Componants/footerPages/weAre/WeAre.jsx";
import Conditions from "./Componants/footerPages/conditions/Conditions.jsx";
import Policies from "./Componants/footerPages/policies/Policies.jsx";
import Contacts from "./Componants/footerPages/contacts/Contacts.jsx";
import LoginPage from "./Componants/loginpage/LoginPage.jsx";
import SignupPage from "./Componants/loginpage/Signup.jsx";
import FlashSaleViews from "./ViewProducts/FlashSaleViews.jsx";
import DistinctiveItemsViews from "./ViewProducts/DistinctiveItemsViews.jsx";
import ProductOffersViews from "./ViewProducts/FlashSaleViews.jsx";
import ShopByCategoryView from "./ViewProducts/ShopByCategoryView.jsx";
import RelatedProductsView from "./ViewProducts/RelatedProductsView.jsx";
import {AddressProvider} from "./Componants/checkout/AddressContext.jsx";
import AppCanvas from "./Componants/virtualTryOn/AppCanvas.jsx";
import SimpleVTO from "./Componants/virtualTryOn/SimpleVTO.jsx";
import ChatWidget from "./Componants/chatbot/ChatWidget.jsx";
const languages = [
	{
		code: "en",
		name: "English",
		country_code: "gb",
	},
	{
		code: "ar",
		name: "العربية",
		dir: "rtl",
		country_code: "sa",
	},
];

function App() {
	const [modelHander, setModelHander] = useState(false);
	// const openModelHandler = () => {
	//   setModelHander(true)
	// }
	const closeModelHandler = () => {
		setModelHander(false);
	};
	const [tabe, setTabChosen] = useState("user");
	// const navigate=useNavigate()
	const token = cookies.get("user");
	const currentLanguageCode = cookies.get("i18next") || "en";
	const currentLanguage = languages.find(l => l.code === currentLanguageCode);
	const {t} = useTranslation();

	const [personal, setpersonal] = useState({});
	const update_p = async () => {
		const token = cookies.get("user");
		if (token !== undefined) {
			var p = await update();
			setpersonal(p);
		} else {
			setpersonal({cart: [], wish: []});
		}
	};

	useEffect(() => {
		update_p();
	}, []);

	useEffect(() => {
		document.body.dir = currentLanguage.dir || "ltr";
		// document.title = t("app_title");
	}, [currentLanguage, t]);
	const [langcode, setLangcode] = useState(currentLanguageCode);
	const [lang, setLang] = useState(currentLanguage);
	React.useEffect(() => {}, [lang]);

	return (
		<ShoppinghcartProvider className="App">
			<AddressProvider>
				<BrowserRouter className="App ">
					<Layout
						lang={lang}
						langcode={langcode}
						personal={personal}
						update_p={update_p}
					></Layout>
					<Routes>
						<Route
							path="/c/:id"
							element={
								<Home
									personal={personal}
									update_p={update_p}
								/>
							}
						/>
						<Route
							path="/checkout"
							element={<Checkout />}
						/>
						<Route
							path="/productdetails/:id"
							element={
								<Productdetails
									personal={personal}
									update_p={update_p}
								/>
							}
						/>
						{token && (
							<Route
								path="/profile"
								element={
									<Profile
										personal={personal}
										update_p={update_p}
									/>
								}
							/>
						)}
						<Route
							path="/cart"
							element={
								<Cart
									personal={personal}
									update_p={update_p}
								/>
							}
						/>
						<Route
							path="/SubcatigoryPage"
							element={<SubcatigoryPage />}
						/>
						<Route
							path="/SubcatigoryPage/:id/:page"
							element={
								<SubcatigoryPage
									personal={personal}
									update_p={update_p}
								/>
							}
						/>
						<Route
							path="/SearchPage/*"
							element={
								<SearchPage
									personal={personal}
									update_p={update_p}
								/>
							}
						/>
						<Route
							path="/wishlist"
							element={
								<Wishlist
									personal={personal}
									update_p={update_p}
								/>
							}
						/>
						<Route
							path="/"
							element={<RouteRedirect />}
						/>
						<Route
							path="*"
							element={<NotFoundPage />}
						/>
						<Route
							path="/sections"
							element={<Sections />}
						/>
						<Route
							path="/sections"
							element={<Sections />}
						/>
						<Route
							path="/search-results/:searchKey/:page"
							element={
								<SearchProduct
									personal={personal}
									update_p={update_p}
								/>
							}
						/>
						{/* Virtual try on routes */}
						<Route
							path="/virtual-try-on"
							element={
								<AppCanvas
									personal={personal}
									update_p={update_p}
								/>
							}
						/>

						<Route
							path="/simple-virtual-try-on"
							element={<SimpleVTO />}
						/>

						{/* burger routes */}
						<Route
							path="/returns"
							element={<Recovery />}
						/>
						<Route
							path="/mywallet"
							element={<Wallet />}
						/>
						<Route
							path="/wallet"
							element={<WalletPopup />}
						/>
						<Route
							path="/myorders"
							element={<Orders />}
						/>
						<Route
							path="/addresses"
							element={<Location />}
						/>
						<Route
							path="/custom"
							element={<CustomResponse />}
						/>
						<Route
							path="/search-result"
							element={
								<SearchResult
									personal={personal}
									update_p={update_p}
								/>
							}
						/>
						<Route
							path="/changepassword"
							element={<ChangePassword />}
						/>
						<Route
							path="/deleteaccount"
							element={
								<Modall
									setTabChosen={setTabChosen}
									modelHander={modelHander}
									onClose={closeModelHandler}
								/>
							}
						/>
						{/* footer Pages */}
						<Route
							path="/weare"
							element={<WeAre />}
						/>
						<Route
							path="/conditions"
							element={<Conditions />}
						/>
						<Route
							path="/policies"
							element={<Policies />}
						/>
						<Route
							path="/Contacts"
							element={<Contacts />}
						/>
						<Route
							path="/login"
							element={<LoginPage />}
						/>
						<Route
							path="/signup"
							element={<SignupPage />}
						/>
						{/* views */}
						<Route
							path="/flashsale/:categoryId/:page"
							element={
								<FlashSaleViews
									personal={personal}
									update_p={update_p}
								/>
							}
						/>
						<Route
							path="/distinctiveitems/:categoryId/:page"
							element={
								<DistinctiveItemsViews
									personal={personal}
									update_p={update_p}
								/>
							}
						/>
						<Route
							path="/offersproducts/:categoryId/:page"
							element={
								<ProductOffersViews
									personal={personal}
									update_p={update_p}
								/>
							}
						/>
						<Route
							path="/shopbycategory/:categoryId/:subId/:page"
							element={
								<ShopByCategoryView
									personal={personal}
									update_p={update_p}
								/>
							}
						/>
						<Route
							path="/relatedproducts/:categoryId/:productId/:page"
							element={<RelatedProductsView />}
						/>
					</Routes>
					<Fotter></Fotter>
					<>
						{/* <a
          className=""
          style={{ textDecoration: "none" }}
          data-bs-toggle="modal"
          href="#confpay"
        >
          {" "}
          pay
        </a> */}
						<div
							style={{direction: "ltr"}}
							className="modal fade"
							id="Forgot"
							aria-hidden="true"
							aria-labelledby="exampleModalToggleLabel2"
							tabIndex="-1"
						>
							<div className="modal-dialog modal-dialog-centered">
								<div className="modal-content">
									<div
										style={{
											position: "relative",
											left: "1rem",
											top: "1rem",
										}}
									>
										<button
											type="button"
											className="btn-close"
											data-bs-dismiss="modal"
											aria-label="Close"
										></button>
									</div>
									<div className="modal-body">
										<ForgitPassPop></ForgitPassPop>
									</div>
								</div>
							</div>
						</div>
						<div
							style={{direction: "ltr"}}
							className=" modal fade "
							id="sendE"
							tabIndex="-1"
							aria-labelledby="exampleModalToggleLabel"
							aria-hidden="true"
						>
							<div className="modal-dialog ">
								<div className="modal-content ">
									<div
										style={{
											position: "relative",
											left: "1rem",
											top: "1rem",
										}}
									>
										<button
											type="button"
											className="btn-close"
											data-bs-dismiss="modal"
											aria-label="Close"
										></button>
									</div>
									<div>
										<ConfirmemailPop></ConfirmemailPop>
									</div>
								</div>
							</div>
						</div>
						<div
							style={{direction: "ltr"}}
							className=" modal fade "
							id="sende"
							tabIndex="-1"
							aria-labelledby="exampleModalToggleLabel"
							aria-hidden="true"
						>
							<div className="modal-dialog ">
								<div className="modal-content ">
									<div
										style={{
											position: "relative",
											left: "1rem",
											top: "1rem",
										}}
									>
										<button
											type="button"
											className="btn-close"
											data-bs-dismiss="modal"
											aria-label="Close"
										></button>
									</div>
									<div>
										<ConfirmemailPop></ConfirmemailPop>
									</div>
								</div>
							</div>
						</div>
						<div
							style={{direction: "ltr"}}
							className="modal fade"
							id="confpay"
							aria-hidden="true"
							aria-labelledby="exampleModalToggleLabel2"
							tabIndex="-1"
						>
							<div className="modal-dialog modal-dialog-centered">
								<div className="modal-content">
									<div
										style={{
											position: "relative",
											left: "1rem",
											top: "1rem",
										}}
									>
										<button
											type="button"
											className="btn-close"
											data-bs-dismiss="modal"
											aria-label="Close"
										></button>
									</div>
									<div className="d-flex justify-content-center">
										<Confirmpayment></Confirmpayment>
									</div>
								</div>
							</div>
						</div>
						<div
							style={{direction: "ltr"}}
							className="modal fade"
							id="confpay2"
							aria-hidden="true"
							aria-labelledby="exampleModalToggleLabel2"
							tabIndex="-1"
						>
							<div className="modal-dialog modal-dialog-centered">
								<div className="modal-content">
									<div
										style={{
											position: "relative",
											left: "1rem",
											top: "1rem",
										}}
									>
										<button
											type="button"
											className="btn-close"
											data-bs-dismiss="modal"
											aria-label="Close"
										></button>
									</div>
									<div className=" d-flex justify-content-center">
										<Confirmpayment2></Confirmpayment2>
									</div>
								</div>
							</div>
						</div>
					</>
					<ChatWidget />
				</BrowserRouter>
			</AddressProvider>
		</ShoppinghcartProvider>
	);
}

export default App;
